import { useState } from 'react'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { AlmanacFile, MediaObject } from 'types'
import { fetchFile } from 'utils/fileDownloadUtils'
import { downloadFile as exportFile } from 'components/VisualStudioPlayground/VisualEditor/utils/export/downloadFile'

export const useDownloadMediaFile = () => {
  const [isDownloading, setIsDownloading] = useState(false)

  const downloadFile = async (file: AlmanacFile | MediaObject) => {
    if (!file.source_url) return

    setIsDownloading(true)
    const dismissToast = showToastMessage('Downloading...', 'loading')

    try {
      await fetchFile({ url: file.source_url }).then((fetchedFile) => exportFile(fetchedFile))
    } catch {
      dismissToast()
      showToastMessage('We were unable to download your file', 'error')
      setIsDownloading(false)
    }

    setIsDownloading(false)
    showToastMessage('Download complete!')
    dismissToast()
  }

  return { isDownloading, downloadFile }
}
